export type AppPage =
  | "home"
  | "docs"
  | "docs-topic"
  | "pricing"
  | "privacy"
  | "terms"
  | "login"
  | "launch"
  | "launch-success"
  | "dashboard"
  | "app-docs"
  | "settings"
  | "admin-users"
  | "sites"
  | "site-detail"
  | "accounts"
  | "not-found"

export function resolvePage(pathname: string): AppPage {
  const normalized = pathname.replace(/\/+$/, "") || "/"

  switch (normalized) {
    case "/":
      return "home"
    case "/docs":
      return "docs"
    case "/pricing":
      return "pricing"
    case "/privacy":
      return "privacy"
    case "/terms":
      return "terms"
    case "/login":
      return "login"
    case "/launch":
      return "launch"
    case "/launch/success":
      return "launch-success"
    case "/app":
      return "dashboard"
    case "/app/docs":
      return "app-docs"
    case "/app/settings":
      return "settings"
    case "/app/admin/users":
      return "admin-users"
    case "/app/sites":
      return "sites"
    case "/app/accounts":
      return "accounts"
    default:
      if (normalized.startsWith("/docs/")) {
        return "docs-topic"
      }
      if (normalized.startsWith("/app/sites/")) {
        return "site-detail"
      }
      return "not-found"
  }
}
